require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./responsive-web-design-applied-accessibility-improve-accessibility-of-audio-content-with-the-audio-element.json") })
        }
      }, "path---responsive-web-design-applied-accessibility-improve-accessibility-of-audio-content-with-the-audio-element");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---responsive-web-design-applied-accessibility-improve-accessibility-of-audio-content-with-the-audio-element!./.cache/json/responsive-web-design-applied-accessibility-improve-accessibility-of-audio-content-with-the-audio-element.json
// module id = 2516
// module chunks = 231608221292675